<template>
  <div>
    <b-row>
      <b-col
        xl="12"
        md="12"
      >
        <b-row
          align-h="between"
          align-v="center"
        >
          <b-col
            v-if="isEdit"
            xl="6"
            md="12"
          >
            <h5>Daftar Produk Koleksi <strong>{{ form.title }}</strong></h5>
            <p class="text-muted">
              <span class="text-capitalize">
                {{ form.type }}
              </span>
              <span v-if="form.category">
                | Kategori {{ form.category.name }}
              </span>
            </p>
          </b-col>
          <b-col
            xl="auto"
            md="auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="onOpenSearch"
            >
              Tambah Produk
            </b-button>
          </b-col>
        </b-row>
        <hr
          class="my-1"
        >
        <b-row>
          <b-col
            xl="8"
            md="12"
          >
            <div
              class="mb-4"
            >
              <div
                class="mb-1"
              >
                <strong>{{ productsAdded.length }} </strong>
                <span class="text-muted">Produk ditambahkan</span>
              </div>

              <div v-if="productsAdded && productsAdded.length">
                <div
                  v-for="(item, index) in productsAdded"
                  :key="`list-item-${index}`"
                >
                  <b-row
                    align-h="between"
                    align-v="center"
                  >
                    <b-col
                      cols="10"
                    >
                      <ProductItem
                        :img="item.images.length ? item.images[0].image_url : ''"
                        :title="item.name"
                        :subtitle="`by ${item.merchant.name}`"
                        :badge="!item.is_out_of_stock ? '' : 'light-danger|Stok Habis'"
                        :price="toCurrency(item.variant ? item.variant.price : item.price)"
                        class="mb-1"
                      />
                    </b-col>
                    <b-col
                      cols="2"
                      class="text-right"
                    >
                      <b-button
                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                        variant="flat-danger"
                        class="btn-icon rounded-circle"
                        @click="onDetach(item)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <hr
                    v-if="productsAdded.length !== index+1"
                    class="my-1"
                  >
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal
      v-model="isShowSearch"
      title="Cari Produk untuk ditambahkan ke Koleksi"
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <SearchProduct
          ref="searchProduct"
          :filter="collection.category ? { 'filter[category]': collection.category.id } : undefined"
          :init-selected-item="productsAdded"
          :advance="false"
          shadow-item
          selected-indicator
          @on-select="onAttach"
        >
          <template #content>
            <b-alert
              v-if="collection.category"
              variant="primary"
              show
              class="mt-50"
            >
              <span>Menampilkan produk kategori <strong>{{ collection.category.name }}</strong></span>
            </b-alert>
          </template>
        </SearchProduct>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  BRow,
  BCol,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProductItem from '@/layouts/components/custom/ProductItem.vue'
import SearchProduct from '@/layouts/components/custom/SearchProduct.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BAlert,
    ProductItem,
    SearchProduct,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShowSearch: false,
      productsAdded: [],
    }
  },
  computed: {
    ...mapState('collections', ['collection']),
    collectionId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  watch: {
    form() {
      if (this.form.products && this.form.products.length) this.productsAdded = this.form.products
    },
  },
  methods: {
    ...mapActions('collections', ['onAttachProduct', 'onDetachProduct']),
    async onOpenSearch() {
      this.$store.commit('products/RESET_PRODUCT_SEARCH')
      this.isShowSearch = true
    },
    async callbackAttach(data) {
      this.productsAdded.push(data)
      this.isShowSearch = false
    },
    async onDetach(data) {
      await this.onDetachProduct({
        collectionId: this.collectionId,
        productId: data.id,
      })
      const getIndex = this.productsAdded.findIndex(el => el.id === data.id)
      this.productsAdded.splice(getIndex, 1)
    },
    async onAttach(data) {
      this.isShowSearch = false
      // this.productsAdded.push(data)

      await this.onAttachProduct({
        collectionId: this.form.id,
        productId: data.id,
      })
    },
  },
}
</script>
